export default "__VITE_ASSET__C9Dmpb76__"